import { createSlice } from "@reduxjs/toolkit";
import type { RootState } from "../../store";
import { endpoints } from "../../../services/admin-service/countryApi/countryApi";
import { ICountryState } from "./types";
import type { ICountry } from "../../../services/admin-service/countryApi/types";

export const countryInitialState:ICountryState  = {};

const countrySlice = createSlice({
  name: "country",
  initialState: countryInitialState,
  reducers: {
  },
  extraReducers: (builder) => {  
    builder.addMatcher(
      endpoints.listCountries.matchFulfilled,
      (state, { payload }) => {
        state.countries = [...payload.results];
      }
    );
   
  },
});

export const selectCurrentCountries = (state: RootState) =>
  state.country.countries;

export const selectCountryByCode = (
  state: RootState,
  countryId: number
): ICountry | undefined => {
  return state?.country?.countries?.find(
    (country) => country?.id === countryId
  );
};

export const selectUserCountry = (state: RootState): ICountry | undefined => {
  const user = state.auth.user;
  if (user?.countryId) {
    return selectCountryByCode(state, user.countryId);
  }
  return undefined;
};


export default countrySlice.reducer;
